
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import hexsha1 from '../../../static/js/hex-sha1'
export default {
name: 'register',
components: {Group, XInput, XButton, Toast, Countdown, Alert},
data () {
return {
$vue: '',
phone: '',
verificationCode: '',
password: '',
twoPassword: '',
verificationContent: '发送验证码',
cannotSendCode: false,
cdTime: 0,
showCdTime: true,
startCountDown: false,
isShowLoading: false,
buttonText: '快速注册',
position: 'bottom',
showPositionValue: false,
errorText: '',
showSuccess: false
}
},
beforeMount () {
this.$vue = this
},
methods: {

send () {

this.$validator.validate('mobile').then((result) => {
if (!result) {
if (this.error.has('mobile')) {
this.showPosition(this.error.first('mobile'))
}
} else {

this.sendVerificationCode()
}
})
},

async sendVerificationCode () {

if (this.cdTime !== 0 && this.cdTime !== undefined) {
return
}

let params = new URLSearchParams()
params.append('phone', this.phone.toString())
let suc = await this.$http.post(this.$vue.getData('FAST_REGISTER_CODE_URL'), params)
if (suc.data.result === '1') {

this.cdTime = 60
this.verificationContent = '秒后再次发送'
this.startCountDown = true
this.cannotSendCode = true
this.showCdTime = true
this.showPosition('发送成功')
} else {
this.showPosition(suc.data.data)
}
},

finishCountDown () {
this.showCdTime = false
this.verificationContent = '发送验证码'
this.startCountDown = false
this.cannotSendCode = false
},

showPosition (text) {
this.errorText = text
this.showPositionValue = true
},

fastRegister () {

this.$validator.validateAll().then((result) => {
if (!result) {
if (this.error.has('mobile')) {
this.showPosition(this.error.first('mobile'))
return
}
if (this.error.has('verificationCode')) {
this.showPosition(this.error.first('verificationCode'))
return
}
if (this.error.has('password')) {
this.showPosition(this.error.first('password'))
}
} else {

if (this.password !== this.twoPassword) {
this.showPosition('两次密码输入不正确')
} else {
this.submitFastRegister()
}
}
})
},

async submitFastRegister () {

this.buttonText = '提交中...'
this.isShowLoading = true
let params = new URLSearchParams()
params.append('verificationCode', this.verificationCode)
params.append('phone', this.phone.toString())
params.append('psw', hexsha1.hex_sha1(this.password))
let suc = await this.$http.post(this.$vue.getData('FAST_REGISTER_SUBMIT_URL'), params)

this.buttonText = '快速注册'
this.isShowLoading = false
if (suc.data.result === '1') {
this.showSuccess = true
setTimeout(() => {
this.showSuccess = false
}, 3000)
} else {
this.showPosition(suc.data.data)
}
},
regSuc () {
this.$router.push({name: 'Login'})
}
}
}



// WEBPACK FOOTER //
// ./src/components/login/register.vue